import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ILifecycleService = ( createDecorator('lifecycleService'));
export { ILifecycleService };
